import React from 'react';

const Modal = ({ isOpen, onClose, onConfirm, title, children }) => {
  if (!isOpen) return null;

  // Cette fonction empêche le clic à l'intérieur du modal de fermer la fenêtre
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    // L'arrière-plan sombre. Le clic dessus fermera le modal.
    <div 
      onClick={onClose} 
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 transition-opacity animate-fade-in"
    >
      <div 
        onClick={handleModalContentClick}
        className="bg-pro-dark-surface rounded-lg shadow-xl p-6 w-full max-w-md mx-4 transform transition-all animate-zoom-in"
      >
        <h3 className="text-lg font-bold text-pro-dark-text-primary">{title}</h3>
        <div className="mt-2 text-sm text-pro-dark-text-secondary">
          {children}
        </div>
        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-pro-dark-text-secondary bg-pro-dark-border rounded-md hover:bg-gray-600 transition-colors"
          >
            Annuler
          </button>
          <button
            // La fonction onConfirm est appelée ici
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
          >
            Confirmer la suppression
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;